import React from 'react'

const AuthUserContext = React.createContext({
  authUser: null,
  updateAuthUserPrefs: () => {},
})

export default AuthUserContext
